<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="
            id
              ? $i18n.t('Edit Supervisor - ') + superv.name
              : $i18n.t('Create Supervisor')
          "
          icon="mdi-account-tie"
          class="px-3 py-3"
          color="primary"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-container class="py-0">
              <v-row style="margin-top:10px">
                <v-col cols="4">
                  <v-text-field
                    :label="$i18n.t('Name') + '*'"
                    :rules="validationrules.name"
                    required
                    v-model="superv.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :label="$i18n.t('Email') + '*'"
                    :rules="validationrules.email"
                    required
                    v-model="superv.email"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="2">
                  <z-country-select
                    :label="$i18n.t('Country Code') + '*'"
                    class="purple-input"
                    v-model="superv.countryCode"
                    isd
                    hideName
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    :label="$i18n.t('Phone') + '*'"
                    :rules="validationrules.phone"
                    required
                    type="number"
                    v-model="superv.phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <z-userRole-select
                    class="purple-input"
                    v-model="superv.role"
                  ></z-userRole-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-entity-select
                    class="purple-input"
                    v-model="superv.entity_id"
                    corp="self"
                  ></z-entity-select>
                </v-col>

                <v-col cols="4">
                  <v-checkbox
                    v-model="superv.viewOwnEntity"
                    :label="$i18n.t('View Own Entity')"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    :label="$i18n.t('Designation')"
                    v-model="superv.designation"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :label="$i18n.t('Department')"
                    v-model="superv.department"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-divider />
              <!-- <v-row>
                <v-col cols="12" md="4">
                  <v-checkbox v-model="superv.isFuelMan" :label="$i18n.t('Fuel Man')"></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="superv.isBooker" :label="$i18n.t('Booker')"></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="superv.isQCMan" :label="$i18n.t('QC Man')"></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="superv.tptMgr" :label="$i18n.t('Transport Manager')"></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox v-model="superv.isFieldManager" :label="$i18n.t('Field Manager')"></v-checkbox>
                </v-col>

                <v-col cols="4">
                  <v-checkbox v-model="superv.fromFinance" :label="$i18n.t('From Finance Team')"></v-checkbox>
                </v-col>
                <v-col v-if="superv.fromFinance" cols="4">
                  <v-checkbox
                    v-model="superv.viewOwnEntity"
                    :label="$i18n.t('View Own Entity Invoice Only')"
                  ></v-checkbox>
                </v-col>
              </v-row>-->
              <v-card>
                <v-card-text>Assign Zone</v-card-text>
                <v-row style="margin-bottom:20px">
                  <v-col v-for="z in zones" :key="z.name">
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="z.selected"
                        :label="`${z.name}`"
                      ></v-checkbox>
                    </v-col>
                  </v-col>
                  <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="superv.no_zone"
                        label="No Zone"
                      ></v-checkbox>
                    </v-col>
                </v-row>
              </v-card>
              <v-card>
                <v-card-text>Assigned City</v-card-text>
                <v-row style="margin-bottom:20px;margin-right:60px">
                  <v-col
                    cols="12"
                    md="2"
                    v-for="city in cityMap"
                    :key="city"
                    style="margin-left:60px"
                    >{{ city }}</v-col
                  >
                </v-row>
              </v-card>
              <v-card>
                <v-card-text>Assigned Client</v-card-text>
                <v-row style="margin-bottom:20px;margin-right:60px">
                  <v-col
                    cols="12"
                    md="3"
                    v-for="client in clients"
                    :key="client"
                    style="margin-left:60px"
                    >{{ client }}</v-col
                  >
                </v-row>
              </v-card>
            </v-container>
            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";

@Component
export default class Tickets extends Vue {
  valid = true;
  superv = {
    name: "",
    email: "",
    no_zone: null,
    zones: [],
    countryCode: 91
  };
  cityMap = [];
  zones = [
    {
      selected: false,
      cities: [],
      _id: "",
    },
  ];
  clients = [];
  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    email: [(v) => !!v || this.$i18n.t("Email is required")],
    phone: [(v) => !!v || this.$i18n.t("Phone no is required")],
  };
  id = "";

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      this.superv.zones = [];
      for (let i = 0; i < this.zones.length; i++) {
        if (this.zones[i].selected) {
          this.superv.zones.push(this.zones[i]._id);
        }
      }
      if (this.superv.no_zone) {
        this.superv.zones.push("NO_ZONE");
      }
      // console.log(this.superv);
      common.setLoading(true);
      this.superv = await doPost("/api/supervisor/save", this.superv);
      this.$router.push("/settings/supervisor/" + this.superv._id);
      this.get(this.superv._id);
      common.showMessage("Saved Successfully");
      common.setLoading(false);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.superv = await doGet("/api/supervisor/" + id + "/get");
      await this.findClients(this.$route.params.id);
      await this.findZone();
    } catch (e) {
      common.setError(e.message);
    }
  }

  async findClients(id) {
    try {
      this.clients = await doGet("/api/supervisor/" + id + "/clientsByZone");
      // console.log(this.clients);
    } catch (e) {
      console.log(e);
    }
  }

  async findZone() {
    try {
      const res = await doGet("/api/zone/data");
      this.zones = res.rows;
      this.cityMap = [];
      if (this.zones.length > 0) {
        for (let i = 0; i < this.zones.length; i++) {
          if (this.superv.zones.length > 0) {
            for (let j = 0; j < this.superv.zones.length; j++) {
              if (this.superv.zones[j] == this.zones[i]._id) {
                this.zones[i].selected = true;
                if (
                  this.zones[i].cities !== undefined &&
                  this.zones[i].cities.length > 0
                ) {
                  for (let k = 0; k < this.zones[i].cities.length; k++) {
                    this.cityMap.push(this.zones[i].cities[k]);
                  }
                }
              }
              if (this.superv.zones[j] == "NO_ZONE") {
                this.superv.no_zone = true;
              }
            }
            // console.log(this.cityMap);
          } else {
            this.zones[i].selected = false;
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    await init.getUrlParameter("forCorp");
    if (init.urlParam) {
      this.superv.adminOf = init.urlParam;
    }
    this.findZone();
  }
}
</script>

<style scoped>
.week-button {
  padding: 5px 4px;
  height: 30px;
  width: 30px;
  justify-content: center;
}
</style>
